module.exports = __webpack_public_path__ + "static/media/ontransit-activity-marker.f83d3cff.png";